import React from "react";
import styles from "../Pricing.module.scss";

function Surcharge({ activeApp }) {
  const getPricingDataById = (id) => {
    let pricing = activeApp?.prices?.find((price) => price.id === id);
    return pricing ? pricing.pivot : { dollars: 0, percent: 0 };
  };

  const hasValidPricing = (pricingId) => {
    const pricing = getPricingDataById(pricingId);
    return pricing.dollars > 0 || pricing.percent > 0;
  };

  const renderDataItem = (label, value) => (
    <div className={styles.fee_item}>
      <div className={styles.fee_content}>
        <div className={styles.fee_label}>{label}</div>
        <div className={styles.fee_value}>{value}</div>
      </div>
    </div>
  );

  return (
    <div className={styles.surcharge}>
      {hasValidPricing(35) && (
        <div className={styles.surcharge_section}>
          <div className={styles.fees_grid}>
            {renderDataItem("Surcharge Rate", `${getPricingDataById(35).percent}%`)}
            {renderDataItem("Per Txn", `$ ${getPricingDataById(35).dollars}`)}
            {renderDataItem("Monthly fee", `$ ${getPricingDataById(17).dollars}/mo`)}
          </div>
        </div>
      )}
    </div>
  );
}

export default Surcharge; 